module.exports = __webpack_public_path__ + "static/M2-d84b155ada5e3ed500959d296625dc17.jpg";